import React, { Component } from 'react';
import { withRouter } from 'react-router'

import './index.css';
class Sidebar extends Component {
  constructor() {
    super();

    this.isRouteActive = this.isRouteActive.bind(this);
  }

  render() {

    const temp = [
      { text: 'Portlets', route: 'portlets', icon: portletsIcon },
      // { text: 'Help', route: 'help', icon: settingsIcon }
    ]

    const sidebarEntries = temp.map((item) => {
      return (
        <SidebarEntry 
        key={item.text} 
        onClickHandler={this.d} 
        text={item.text} 
        icon={item.icon} 
        active={this.isRouteActive(item.route)}/>
      );
    });


    return (
      <div className="sidebar_root">
        <div className="title">
          MANAGEMENT CONSOLE
        </div>

        <div className="entries">
          {sidebarEntries}
        </div>

      </div>
    );
  }

  isRouteActive(val) {
    const path = this.props.location.pathname;
    const regExp = new RegExp('/' + val + '.*');

    return regExp.test(path); 
  }
}

export default withRouter(Sidebar);


class SidebarEntry extends Component {
  render() {
    return (
      <div className={this.props.active ? "entry_wrapper active" : "entry_wrapper"} onClick={this.props.onClickHandler}>
        <div className="icon">{this.props.icon}</div>
        <div className="text">{this.props.text}</div>
      </div>
    );
  }
}




const portletsIcon = (
  <svg x="0px" y="0px" width="512px" height="512px" viewBox="0 0 511.626 511.627">
    <g>
      <g>
        <path d="M118.771,200.999H27.406c-7.611,0-14.084,2.664-19.414,7.994C2.663,214.32,0,220.791,0,228.407v54.823    c0,7.61,2.663,14.078,7.992,19.406c5.33,5.329,11.803,7.994,19.414,7.994h91.365c7.611,0,14.084-2.665,19.414-7.994    c5.33-5.328,7.992-11.796,7.992-19.406v-54.823c0-7.616-2.662-14.087-7.992-19.414S126.382,200.999,118.771,200.999z" />
        <path d="M118.771,54.814H27.406c-7.611,0-14.084,2.663-19.414,7.993C2.663,68.137,0,74.61,0,82.221v54.821    c0,7.616,2.663,14.091,7.992,19.417c5.33,5.327,11.803,7.994,19.414,7.994h91.365c7.611,0,14.084-2.667,19.414-7.994    s7.992-11.798,7.992-19.414V82.225c0-7.611-2.662-14.084-7.992-19.417C132.855,57.48,126.382,54.814,118.771,54.814z" />
        <path d="M118.771,347.177H27.406c-7.611,0-14.084,2.662-19.414,7.994C2.663,360.502,0,366.974,0,374.585v54.826    c0,7.61,2.663,14.086,7.992,19.41c5.33,5.332,11.803,7.991,19.414,7.991h91.365c7.611,0,14.084-2.663,19.414-7.991    c5.33-5.324,7.992-11.8,7.992-19.41v-54.826c0-7.611-2.662-14.083-7.992-19.411S126.382,347.177,118.771,347.177z" />
        <path d="M484.215,200.999H210.131c-7.614,0-14.084,2.664-19.414,7.994s-7.992,11.798-7.992,19.414v54.823    c0,7.61,2.662,14.078,7.992,19.406c5.327,5.329,11.8,7.994,19.414,7.994h274.091c7.61,0,14.085-2.665,19.41-7.994    c5.332-5.328,7.994-11.796,7.994-19.406v-54.823c0-7.616-2.662-14.087-7.997-19.414    C498.3,203.663,491.833,200.999,484.215,200.999z" />
        <path d="M484.215,347.177H210.131c-7.614,0-14.084,2.662-19.414,7.994c-5.33,5.331-7.992,11.8-7.992,19.41v54.823    c0,7.611,2.662,14.089,7.992,19.417c5.327,5.328,11.8,7.987,19.414,7.987h274.091c7.61,0,14.085-2.662,19.41-7.987    c5.332-5.331,7.994-11.806,7.994-19.417v-54.823c0-7.61-2.662-14.085-7.997-19.41C498.3,349.846,491.833,347.177,484.215,347.177z" />
        <path d="M503.629,62.811c-5.329-5.327-11.797-7.993-19.414-7.993H210.131c-7.614,0-14.084,2.663-19.414,7.993    s-7.992,11.803-7.992,19.414v54.821c0,7.616,2.662,14.083,7.992,19.414c5.327,5.327,11.8,7.994,19.414,7.994h274.091    c7.61,0,14.078-2.667,19.41-7.994s7.994-11.798,7.994-19.414V82.225C511.626,74.613,508.964,68.141,503.629,62.811z" />
      </g>
    </g>
  </svg>
);

const settingsIcon = (
  <svg x="0px" y="0px" viewBox="0 0 426.667 426.667">
    <g>
      <g>
        <rect x="192" y="298.667" width="42.667" height="42.667" />
      </g>
    </g>
    <g>
      <g>
        <path d="M213.333,0C95.513,0,0,95.513,0,213.333s95.513,213.333,213.333,213.333s213.333-95.513,213.333-213.333    S331.154,0,213.333,0z M213.333,388.053c-96.495,0-174.72-78.225-174.72-174.72s78.225-174.72,174.72-174.72    c96.446,0.117,174.602,78.273,174.72,174.72C388.053,309.829,309.829,388.053,213.333,388.053z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M296.32,150.4c-10.974-45.833-57.025-74.091-102.858-63.117c-38.533,9.226-65.646,43.762-65.462,83.384h42.667    c2.003-23.564,22.729-41.043,46.293-39.04s41.043,22.729,39.04,46.293c-4.358,21.204-23.38,36.169-45.013,35.413    c-10.486,0-18.987,8.501-18.987,18.987v0v45.013h42.667v-24.32C279.787,241.378,307.232,195.701,296.32,150.4z" />
      </g>
    </g>
  </svg>
);


// WEBPACK FOOTER //
// ./src/routes/components/Sidebar/index.js